import { Button, Form } from 'antd';
import { FC, useState } from 'react';

import { CheckBoxField, FormItem, SubmitButton } from 'componets/form';

import { Rules } from 'utils/constants';

import { useTranslate } from 'hooks';

import { FieldData } from 'models';

import styles from './index.module.scss';

interface BearLossCalculatorResultProps {
	amount: number;
	onRecheck: () => void;
	isForm: boolean;
	onFinish: () => void;
	isResave: boolean;
}
export const BearLossCalculatorResult: FC<BearLossCalculatorResultProps> = ({
	amount,
	onRecheck,
	isForm,
	onFinish,
	isResave,
}) => {
	const {
		bearLossCalculatorResultText,
		saveText,
		bearLossCheckboxText,
		abilityToLossText,
		recheckText,
		resaveText,
	} = useTranslate([
		'saveText',
		'bearLossCalculatorResultText',
		'bearLossCheckboxText',
		'abilityToLossText',
		'recheckText',
		'resaveText',
	]);

	const [fields, setFields] = useState<FieldData[]>([]);

	return (
		<div>
			<div className={styles.text}>
				{abilityToLossText} &nbsp;
				<span className={styles.amount}>€{+amount < 0 ? 0 : amount}</span>
				<span className={styles.red}>.</span>
			</div>

			<div className={styles.text}>{bearLossCalculatorResultText}</div>

			<Form onFieldsChange={setFields} fields={fields} onFinish={onFinish}>
				{isForm && (
					<FormItem name="agree" rules={[Rules.REQUIRED_CHECKBOX]} className="checkbox">
						<CheckBoxField text={bearLossCheckboxText} />
					</FormItem>
				)}

				<div className="modal-footer">
					{isForm && (
						<SubmitButton
							text={isResave ? resaveText : saveText}
							className={styles.submit}
							classNameWrapper={styles.submitWrapper}
						/>
					)}
					<Button type="default" role="button" onClick={onRecheck} className={styles.cancel}>
						{recheckText}
					</Button>
				</div>
			</Form>
		</div>
	);
};
